var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.43756V4.25004C10.75 1.90716 8.84403 0 6.50001 0C4.15665 0 2.25005 1.90716 2.25005 4.25004V7.43756C1.07641 7.43756 0.125 8.38908 0.125 9.56244V14.8749C0.125 16.0487 1.07641 17 2.25005 17H10.75C11.9234 17 12.875 16.0487 12.875 14.8749V9.56244C12.875 8.38904 11.9234 7.43756 10.75 7.43756ZM7.03129 12.587V14.3437C7.03129 14.6374 6.79371 14.8749 6.50004 14.8749C6.20637 14.8749 5.96875 14.6374 5.96875 14.3437V12.587C5.65693 12.4024 5.43757 12.0765 5.43757 11.6875C5.43757 11.1001 5.91333 10.625 6.50001 10.625C7.08669 10.625 7.56251 11.1001 7.56251 11.6875C7.56255 12.0765 7.34294 12.4024 7.03129 12.587ZM8.62492 7.43756H4.37503V4.25004C4.37503 3.07755 5.32801 2.12498 6.50001 2.12498C7.67144 2.12498 8.62488 3.07755 8.62488 4.25004V7.43756H8.62492Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.3a1952031f2ab70de2d621cb77b0c1a1.svg";
export { ForwardRef as ReactComponent };